import Recipient from "./recipient";
import RecipientFactory from "./recipientFactory";
import {ObjectHelper} from "../../helpers/objectHelper";
import {RelationType} from "../relationType";
import {DurationUnit} from "../../enums/durationUnit";
import IRepo from "../../interfaces/repo";
import Repo from "../../state/modules/repo";
import {InstanceHelper} from "../../helpers/instanceHelper";
import {ArrayHelper} from "../../helpers/arrayHelper";
import {RecipientType} from "../../enums/recipentType";
import BuilderModel from "~/models/tracked/builderModel";
import {NotificationDeliveryMethod} from "~/enums/notificationDeliveryMethod";
import ObjectModelTriggerRecipient from "~/models/objectModels/objectModelTriggerRecipient";
import {DefaultEmailStyle} from "~/enums/defaultEmailStyle";
export default class Notification extends BuilderModel {
  target_action_client_id: string;
  recipients?: { [key: string]: Recipient } = {};
  subject: string = '';
  body: string = '';
  linked_detail_view_id: string;
  is_after: boolean;
  relative_amount: number;
  relative_unit: DurationUnit;
  delivery_methods: NotificationDeliveryMethod[] = [NotificationDeliveryMethod.ViaInSystem];
  except = ['recipients', 'createEmbeddedObject'];
  include_invoice: boolean;
  show_delivery_methods: boolean = true;
  email_style: DefaultEmailStyle = DefaultEmailStyle.Default

  static repo: IRepo<Notification> = new Repo<Notification>('notifications', Notification);

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'recipients': { type: Recipient, relationType: RelationType.dictionary }
    };
  }

  createEmbeddedObject = {
    recipients: (parent, json): Recipient | ObjectModelTriggerRecipient => { return this.recipientFactory.create(parent,false, json.recipient_type);},

  };
  get rootName(): string {
    return 'notifications';
  }

  get recipientClass(){
    return Recipient
  }

  get recipientFactory(){
    return RecipientFactory
  }

  get isCollectionRoot(): boolean {
    return true;
  }

  get childRootName(): string {
    return 'recipients';
  }

  get isValid(): boolean {
    return this.validate( 'toRecipientsArray', 'subject', 'body', 'delivery_methods');
  }

  validate(...props): boolean {
    let valid = true;
    for (let i = 0; i < props.length; i++) {
      const prop = props[i];
      switch (prop) {
        case 'toRecipientsArray':
        case 'delivery_methods':
          valid = InstanceHelper.isPresent(this[prop]);
          break;
        case 'subject':
        case 'body':
          valid = this[prop].trim().length > 0;
          break;
        default:
          break;
      }
      if (!valid) {
        break;
      }
    }
    return valid;
  }

  get recipientsDisplayNames(): string[] {
    return this.recipientsArray.map(r => r.display);
  }

  get recipientsToString(): string {
    return ArrayHelper.toSentence(this.recipientsDisplayNames);
  }

  get recipientsArray(): Recipient[] {
    return ObjectHelper.toArray(this.recipients);
  }

  get toRecipientsArray(): Recipient[] {
    return this.recipientsArray.filter(r => r.recipient_type === RecipientType.to);
  }

  get ccRecipientsArray(): Recipient[] {
    return this.recipientsArray.filter(r => r.recipient_type === RecipientType.cc);
  }

  get hasEmailDeliveryMethod(): boolean {
    return this.delivery_methods.includes(NotificationDeliveryMethod.ViaEmail);
  }

  setDeliveryMethods(methods: NotificationDeliveryMethod[]) {
    if (!methods.includes(NotificationDeliveryMethod.ViaEmail)) {
      this.ccRecipientsArray.forEach(r => r.destroy());
    }
    this.delivery_methods = methods;
  }
}